import React from 'react';
import clsx from 'clsx';
import { TaleemXMark } from './TaleemXMark';

export interface TaleemXWordmarkProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  tone?: 'brand' | 'inherit' | 'dark';
  className?: string;
}

const SIZE_STYLES: Record<
  string,
  {
    container: string;
    text: string;
    markHeight: string;
  }
> = {
  sm: {
    container: 'text-base',
    text: 'font-bold tracking-tight',
    markHeight: '0.70em',
  },
  md: {
    container: 'text-lg sm:text-xl',
    text: 'font-bold tracking-tight',
    markHeight: '0.71em',
  },
  lg: {
    container: 'text-xl sm:text-2xl',
    text: 'font-bold tracking-tight',
    markHeight: '0.72em',
  },
  xl: {
    container: 'text-2xl sm:text-3xl',
    text: 'font-extrabold tracking-tight',
    markHeight: '0.72em',
  },
};

/**
 * TaleemXWordmark
 * Renders the product wordmark inline: text "Taleem" + traced vector mark as the "X".
 */
export const TaleemXWordmark: React.FC<TaleemXWordmarkProps> = ({
  size = 'md',
  tone = 'brand',
  className,
}) => {
  const sizeConfig = SIZE_STYLES[size] || SIZE_STYLES.md;

  const textColor =
    tone === 'brand' ? 'text-brand' : tone === 'dark' ? 'text-slate-900' : 'text-inherit';

  return (
    <span
      className={clsx(
        'inline-flex items-center select-none leading-none',
        sizeConfig.container,
        textColor,
        className
      )}
      role="img"
      aria-label="TaleemX"
    >
      <span className={sizeConfig.text}>Taleem</span>
      <TaleemXMark
        tight
        tone={tone}
        aria-hidden="true"
        style={{
          height: sizeConfig.markHeight,
          width: 'auto',
          marginLeft: '0.04em',
        }}
        className="inline-block"
      />
    </span>
  );
};

export default TaleemXWordmark;
